<template>

  <form method="post" role="form" @submit="submit">

    <div class="form-group">
      <input
        type="text"
        v-model="firstName"
        class="form-control"
        name="firstName"
        placeholder="Jméno">
    </div>

    <div class="form-group">
      <input
        type="text"
        v-model="lastName"
        class="form-control"
        name="lastName"
        placeholder="Příjmení">
    </div>

    <div class="form-group">
      <input
        type="text"
        v-model="mobilePhone"
        class="form-control"
        name="mobilePhone"
        placeholder="Mobilní telefon">
    </div>

    <div class="form-group">
      <input
        type="password"
        v-model="password"
        v-bind:class="{'is-invalid': errors.password}"
        @keyup="passwordKeyup"
        class="form-control"
        name="password"
        placeholder="Heslo">
      <div v-if="errors.password" class="invalid-feedback">{{ errors.password }}</div>
    </div>

    <div class="form-group">
      <input
        type="password"
        v-model="passwordVerify"
        v-bind:class="{'is-invalid': errors.passwordVerify}"
        @keyup="passwordKeyup"
        class="form-control"
        name="passwordVerify"
        placeholder="Ověření hesla">
      <small v-if="errors.passwordVerify" class="invalid-feedback">{{ errors.passwordVerify }}</small>
    </div>

    <div class="form-group clearfix">
      <div class="checkbox-custom checkbox-inline checkbox-primary float-left">
        <input type="checkbox" id="inputCheckbox" name="term">
        <label for="inputCheckbox"></label>
      </div>
      <p class="ml-40">By clicking Sign Up, you agree to our <a href="#">Terms</a>.</p>
    </div>
    <button type="button" class="btn btn-primary btn-block" @click="submit">Registrovat</button>
  </form>

</template>

<script>
import { http } from '@/http'

export default {
  props:   ['defaultData'],
  data () {
    return {
      firstName:      '',
      lastName:       '',
      mobilePhone:    '',
      password:       '',
      passwordVerify: '',

      errors: {
        password:       null,
        passwordVerify: null
      }
    }
  },
  methods: {
    passwordKeyup () {
      if (this.passwordVerify !== this.password) {
        this.errors.passwordVerify = 'Hesla nejsou shodná'
        this.errors.password       = 'Hesla nejsou shodná'
      }
      else {
        this.errors.passwordVerify = null
        this.errors.password       = null
      }
    },
    submit (event) {
      event.preventDefault()

      if (this.hasErrors()) {
        return
      }

      let data = {
        FirstName:   this.firstName,
        LastName:    this.lastName,
        MobilePhone: this.mobilePhone,
        Password:    this.password,
        Email:       this.defaultData.email,
        IDtLanguage: this.defaultData.iDtLanguage
      }

      /* odeslani pozadavku */
      http.put(
        `User/` + this.defaultData.id,
        data
      )
        /* zpracovani pozadavku */
          .then(response => {
            this.$router.push({ name: 'Dashboard' })
            this.cleanSingUp()
          })

          .catch(e => {
            let message = 'Při odesílání požadavku došlo k chybě (' + e.message + ')'
            this.$emit('showMessage', { message: message, type: 'error' })
          })
    },
    hasErrors () {
      let hasError = false

      if (!this.password) {
        hasError             = true
        this.errors.password = 'Prosím zadejte heslo'
      }

      if (this.password !== this.passwordVerify) {
        hasError                   = true
        this.errors.password       = 'Hesla nejsou shodná'
        this.errors.passwordVerify = 'Hesla nejsou shodná'
      }

      return hasError
    }
  },
  created () {
    if (!this.defaultData) {
      return
    }

  }
}
</script>

<style scoped>

</style>
